angular.module('leftNavModule', ['ulHeightMoudle','headerModule'])
    .controller('leftNavCtrl', ['$scope', '$q', '$state', '$stateParams', "$timeout", 'httpService', "$location", function($scope, $q, $state, $stateParams, $timeout, httpService, $location) {
        initStatus();
        initData();
        /**
         * [selectItem description] 选择模块
         * @param  {[type]} name [description]
         * @return {[type]}      [description]
         */
        $scope.selectItem = function(name, module) {
            var urlName = name === module ? "index." + name : "index." + module + "." + name;
            $state.go(urlName, {}, { reload: urlName });
            $scope.status.selectedItem = name;
            $scope.status.selectedModule = module;
        };
        /**
         * [expand description] 展开节点
         * @param  {[string]} name  [description] 节点名称
         * @return {[type]} [description]
         */
        $scope.expand = function(name) {
            var isExpanded = $scope.isExpanded(name);
            if (isExpanded.flag) {
                $scope.status.expanded.splice(isExpanded.index, 1);
            } else {
                $scope.status.expanded.push(name);
            }
        };
        /**
         * [isExpanded description] 节点是否已经展开
         * @param  {[string]} name  [description] 节点名称
         * @return {[type]} [description]
         */
        $scope.isExpanded = function(name) {
            return {
                flag: $scope.status.expanded.indexOf(name) >= 0,
                index: $scope.status.expanded.indexOf(name)
            };
        };
        /**
         * [initStatus description]初始化状态
         * @param  {[]}  [description]
         * @return {[type]} [description]
         */
        function initStatus() {
            var urlArray = $state.current.name.split(".");
            $scope.status = {
                selectedModule: urlArray[1],
                selectedItem: urlArray.length < 3 ? urlArray[1] : urlArray[2],
                expanded: [urlArray[1]]
            };
            $scope.data = {

            };
        }
        /**
         * [initData description]初始化数据
         * @param  {[]}  [description]
         * @return {[type]} [description]
         */
        function initData() {
            userType();
            unReadMessages();
            queryReadableCount();
            window.addEventListener("storage", function(e) {
                if (e.key === "ls.readMessage") {
                    unReadMessages();
                }
            });
            $scope.$on("readMessage", function() {
                unReadMessages();
            });
            $scope.$on("readRejectionMessage", function() { // 退稿稿库消息
                queryReadableCount();
            });
        }
        /**
         * [initData description]权限
         * @param  {[]}  [description]
         * @return {[type]} [description]
         */
        function userType() {
            var deffer = $q.defer();
            httpService.http("/mcnww/web/user/getLoginUser.do", "", "post").then(function(data) {
                $scope.status.userType = data.loginUser.userType;
                deffer.resolve();
            });
            return deffer.promise;
        }
        
        /**
         * [unReadMessages description] 获取消息数字
         * @return {[type]} [description]
         */
        function unReadMessages() {
            httpService.http("/mcnww/web/message/unReadMessages.do", "", "post").then(function(data) {
                $scope.unReadmessages = data.unReadmessages;
            });
        }

        /**
         * [queryReadableCount description] 获取退稿稿库未读稿件数量
         * @return  {[type]}  [return description]
         */
        function queryReadableCount() {
            httpService.http("/mcnww/web/article/queryReadableCount.do", "", "get").then(function(data) {
                $scope.rejectionUnreadCcount = data.data.count;
            });
        }
    }]);